import React, { useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { isEmpty, startCase } from "lodash";

import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "../Pages/casino/ListHome";
import { t } from "i18next";
import ThemeContext from "../context/ThemeContext";
import FadeInWhenVisible from "./FadeInWhenVisible";
import Loader from "./Loader";
const MenuAccount = () => {
  const setLogoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLogoutShow;
  });

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const setSidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModalAccount;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const toggleTheme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.toggleTheme;
  });
  const sidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModalAccount;
  });
  const refreshAmountLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.refreshAmountLoader;
  });

  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [show, setShow] = useState(true);
  const getImageUrl = (url) => {
    return url;
  };
  return (
    <>
      <div
        id="menu"
        className={`menu ng-tns-c810532393-10 player ng-star-inserted show ${
          sidebarModalAccount ? "active" : ""
        }`}
      >
        <div
          onClick={() => {
            setSidebarModalAccount(false);
            setShow(false);
          }}
          className={`btn-close ng-tns-c810532393-4 ${
            show ? "is-open-member-menu" : ""
          }`}
          style={{
            maskImage: 'url("/assets/Other/icon-close.svg")',
          }}
        />

        <div
          className="menu-first ng-tns-c810532393-10"
          style={{
            width: "360px",
            top: "0px",
            left: "0px",
            background: "#131919",
          }}
        >
          <div
            className="menu-top ng-tns-c810532393-10"
            style={{
              opacity: "1",
              "-webkit-transform": "translate(0px, 0px)",
              "-ms-transform": "translate(0px, 0px)",
              transform: "translate(0px, 0px)",
              width: "360px",
            }}
          >
            <div
              className="menu-header ng-tns-c810532393-10"
              style={{ height: "90px", "border-radius": "0px" }}
            >
              <Loader type="head-coin" />

              <div
                className="member-name ng-tns-c810532393-10 ng-star-inserted"
                style={{ height: "90px" }}
              >
                <div
                  id="account"
                  className="account ng-tns-c810532393-10 ng-star-inserted"
                  style={{ "max-width": "227px" }}
                >
                  <span className="ng-tns-c810532393-10 ng-star-inserted">
                    {user?.user?.username}
                  </span>
                </div>

               
              </div>
            </div>

            {/* <div
              _ngcontent-serverapp-c4204987567
              className="member-header bonuswallet ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c4204987567
                className="member-header-content"
              >
                <div _ngcontent-serverapp-c4204987567 className="user-info">
                  <div
                    _ngcontent-serverapp-c4204987567
                    className="pic pic-lv1 ng-star-inserted"
                    style={{
                      "background-image":
                        'url("https://img.b426b.com/bb/h5/assets/images/player/vip/memberpic-lv1.svg?v=1776751585885")',
                    }}
                  ></div>

                  <div _ngcontent-serverapp-c4204987567 className="infor">
                    <div
                      _ngcontent-serverapp-c4204987567
                      className="account"
                    ></div>
                    <div
                      _ngcontent-serverapp-c4204987567
                      mcdneuaclick
                      className="my-id active"
                    >
                      {" "}
                      ID{" "}
                      <span
                        _ngcontent-serverapp-c4204987567
                        id="memberMenu_header_userId"
                      >
                        {user?.user?.username}
                      </span>
                    </div>
                    <div
                      _ngcontent-serverapp-c4204987567
                      className="vip-points active ng-star-inserted"
                    >
                      <p _ngcontent-serverapp-c4204987567>{t("VIPPointsVP")}</p>
                      <span _ngcontent-serverapp-c4204987567>0</span>
                      <a
                        _ngcontent-serverapp-c4204987567
                        className="my-vip-btn"
                        title="my-vip"
                        href="#"
                      >
                        {t("MyVIP")}{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div
              className="afterlogin marquee ng-tns-c810532393-10 ng-star-inserted"
              style={{
                height: "80px",
                "border-radius": "0px",
                paddingTop: "10px",
              }}
            >
              <div
                style={{ background: "#2a3838" }}
                className="main-wallet ng-tns-c810532393-10"
              >
                <div className="wallet ng-tns-c810532393-10">
                  {" "}
                  {t("MainWallet")}
                  <div
                    onClick={() => amounutRefresh()}
                    className="icon-refresh ng-tns-c810532393-10"
                    style={{
                      "mask-image":
                        'url("/assets/Icon/icon-refresh-type01.svg")',
                    }}
                  />
                </div>
                <div className="amount ng-tns-c810532393-10">
                  <span
                    data-currency="$"
                    className="amount ng-tns-c810532393-10"
                  >
                    <i className="ng-tns-c810532393-10">
                      ৳{userCoins?.totalCoins}
                    </i>
                  </span>
                </div>
              </div>
            </div> */}

            <div
              _ngcontent-serverapp-c4204987567
              className="member-menu-box balance-box ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c4204987567
                className="balance balance-row"
              >
                <div _ngcontent-serverapp-c4204987567 className="text">
                  {" "}
                  {t("MainWallet")}{" "}
                  <div
                    onClick={() => amounutRefresh()}
                    className={`icon refresh ${refreshAmountLoader ? "active" : ""}`}
                    style={{
                      "mask-image":
                        'url("/assets/Icon/icon-refresh-type01.svg")',
                    }}
                  />
                  {/* <div
                    _ngcontent-serverapp-c4204987567
                    className="icon eyes"
                    style={{
                      "mask-image":
                        'url("https://img.b426b.com/bb/h5/assets/images/icon-set/icon-eye-open-type01.svg?v=1776751585885")',
                    }}
                  /> */}
                </div>
                <span
                  _ngcontent-serverapp-c4204987567
                  className="amount totalBalanceWallet"
                >
                  <i _ngcontent-serverapp-c4204987567>
                    <i
                      id="locale-util-dicrective-0"
                      style={{ display: "initial" }}
                    >
                      ৳{userCoins?.totalCoins}
                    </i>
                  </i>
                </span>
                <span
                  _ngcontent-serverapp-c4204987567
                  id="balanceHeader"
                  style={{ display: "none" }}
                >
                  -
                </span>
              </div>
            </div>
          </div>

          <div
            className="member-menu ng-tns-c810532393-10 ng-star-inserted"
            style={{
              display: "block",
              opacity: "1",
              position: "relative",
              paddingTop: "10px",
            }}
          >
            <div
              style={{ position: "fixed",zIndex:"99999999" }}
              onClick={() => {
                setSidebarModalAccount(false);
                setShow(false);
              }}
              _ngcontent-serverapp-c4204987567
              className="close ng-star-inserted"
            />
            <div className="member-menu-content ng-tns-c810532393-10 menu-account-new">
              <div
                className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                style={{
                  opacity: "1",
                  "-webkit-transform": "translate(0px, 0px)",
                  "-ms-transform": "translate(0px, 0px)",
                  transform: "translate(0px, 0px)",
                }}
              >
                <div
                  className="title ng-tns-c810532393-10"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <h2 className="ng-tns-c810532393-10">
                    <span className="ng-tns-c810532393-10">{t("Funds")}</span>
                  </h2>
                </div>
                <ul className="member-menu-item ng-tns-c810532393-10 align-center">
                  <li
                    className="ng-tns-c810532393-10 deposit ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/wallet/deposit" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-deposit.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("Deposit")}</p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 withdrawal ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link
                      to="/wallet/withdraw"
                      className="ng-tns-c810532393-10"
                    >
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage:
                            "url(/assets/Icon/icon-withdrawal.webp)",
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("Withdrawal")}</p>
                    </Link>
                  </li>
                  {/* <li
                    className="ng-tns-c810532393-10 withdrawal ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/free-spin" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage:
                            "url(/assets/Icon/icon-free-spin.webp)",
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("FreeSpin")}</p>
                    </Link>
                  </li> */}
                </ul>
              </div>
              <div
                className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                style={{
                  opacity: "1",
                  "-webkit-transform": "translate(0px, 0px)",
                  "-ms-transform": "translate(0px, 0px)",
                  transform: "translate(0px, 0px)",
                }}
              >
                <div
                  className="title ng-tns-c810532393-10"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <h2 className="ng-tns-c810532393-10">
                    <span className="ng-tns-c810532393-10">
                      {t("MyPromotions")}
                    </span>
                  </h2>
                </div>
                <ul className="member-menu-item ng-tns-c810532393-10">
                  {/* <li
                    className="ng-tns-c810532393-10 deposit ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link
                      to="/real-time-bonus"
                      className="ng-tns-c810532393-10"
                    >
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-real-time-bonus.webp)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("RealTimeBonus")}
                      </p>
                    </Link>
                  </li> */}

                   <li
                    className="ng-tns-c810532393-10 withdrawal ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/refrel" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage:
                            "url(/assets/Icon/icon-referral.webp)",
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("Referral")}</p>
                    </Link>
                  </li>
                  {/*<li
                    className="ng-tns-c810532393-10 withdrawal ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/winner-board" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage:
                            "url(/assets/Icon/icon-winner-board.webp)",
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("WinnerBoardTitle")}
                      </p>
                    </Link>
                  </li> */}
                  {/* <li
                    className="ng-tns-c810532393-10 withdrawal ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link
                      to="/daily-streak-challenge"
                      className="ng-tns-c810532393-10"
                    >
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage:
                            "url(/assets/Icon/icon-daily-login.webp)",
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("DailyStreakChallenge")}
                      </p>
                    </Link>
                  </li> */}
                </ul>
              </div>
              <div
                className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                style={{
                  opacity: "1",
                  "-webkit-transform": "translate(0px, 0px)",
                  "-ms-transform": "translate(0px, 0px)",
                  transform: "translate(0px, 0px)",
                }}
              >
                <div
                  className="title ng-tns-c810532393-10"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <h2 className="ng-tns-c810532393-10">
                    <span className="ng-tns-c810532393-10">{t("History")}</span>
                  </h2>
                </div>
                <ul className="member-menu-item ng-tns-c810532393-10 align-center">
                  <li
                    className="ng-tns-c810532393-10 bet-records ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link
                      to="/betting-history"
                      className="ng-tns-c810532393-10"
                    >
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-bet-records.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("BettingRecords")}
                      </p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 turnover ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/turnover" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-turnover.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("Turnover")}</p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 records ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link
                      to="/transaction-records"
                      className="ng-tns-c810532393-10"
                    >
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-records.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("TransactionRecords")}
                      </p>
                    </Link>
                  </li>
                </ul>
              </div>

              <div
                className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                style={{
                  opacity: "1",
                  "-webkit-transform": "translate(0px, 0px)",
                  "-ms-transform": "translate(0px, 0px)",
                  transform: "translate(0px, 0px)",
                }}
              >
                <div
                  className="title ng-tns-c810532393-10"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <h2 className="ng-tns-c810532393-10">
                    <span className="ng-tns-c810532393-10">{t("Profile")}</span>
                  </h2>
                </div>
                <ul className="member-menu-item ng-tns-c810532393-10 align-center">
                  <li
                    className="ng-tns-c810532393-10 info ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/profile" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-info.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("PersonalInfo")}
                      </p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 myvip ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/affiliate-link" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-real-time-bonus.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("AffiliateLink")}
                      </p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 resetpasswords ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="/reset-password" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-changepassword.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">
                        {t("ResetPassword")}
                      </p>
                    </Link>
                  </li>
                </ul>
              </div>

              <div
                className="member-list member-menu-box ng-tns-c810532393-10 ng-star-inserted"
                style={{
                  opacity: "1",
                  "-webkit-transform": "translate(0px, 0px)",
                  "-ms-transform": "translate(0px, 0px)",
                  transform: "translate(0px, 0px)",
                }}
              >
                <div
                  className="title ng-tns-c810532393-10"
                  style={{
                    opacity: "1",
                    "-webkit-transform": "translate(0px, 0px)",
                    "-ms-transform": "translate(0px, 0px)",
                    transform: "translate(0px, 0px)",
                  }}
                >
                  <h2 className="ng-tns-c810532393-10">
                    <span className="ng-tns-c810532393-10">{t("CONTACTUS")}</span>
                  </h2>
                </div>
                <ul className="member-menu-item ng-tns-c810532393-10 align-center">
                  <li
                    className="ng-tns-c810532393-10 info ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="#" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-customer.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("ChatUs")}</p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 myvip ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="#" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-telegram.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("Telegram")}</p>
                    </Link>
                  </li>

                  <li
                    className="ng-tns-c810532393-10 resetpasswords ng-star-inserted"
                    style={{
                      opacity: "1",
                      "-webkit-transform": "translate(0px, 0px)",
                      "-ms-transform": "translate(0px, 0px)",
                      transform: "translate(0px, 0px)",
                    }}
                  >
                    <Link to="#" className="ng-tns-c810532393-10">
                      <span
                        className="ng-tns-c810532393-10 ng-star-inserted"
                        style={{
                          maskImage: `url(/assets/Icon/icon-email.webp?v=1776751585885)`,
                        }}
                      />

                      <p className="ng-tns-c810532393-10">{t("Email")}</p>
                    </Link>
                  </li>
                </ul>
              </div>

              <div
                onClick={() => setLogoutShow(true)}
                style={{ width: "100%" }}
                className="button btn-primary ng-tns-c810532393-10"
              >
                <Link to="/" className="ng-tns-c810532393-10">
                  {t("LogOut")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="menu-mask ng-tns-c810532393-4 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
        style={{
          display: sidebarModalAccount ? "block" : "none",
          opacity: sidebarModalAccount ? 1 : 0,
        }}
      />
    </>
  );
};

export default MenuAccount;
